import React from 'react';
import {
  ResourcesWrapper,
  ResourcesTitle,
  HeroImage,
  HeroCaption,
  Action,
  ActionsList,
  Occupancy,
} from './Resources.styles';

const Resources: React.FC = () => {
  return (
    <ResourcesWrapper>
      <ResourcesTitle>
        <span role="img" aria-label="books">📚</span> Library Resources
      </ResourcesTitle>
      <HeroImage>
        <HeroCaption>
          <div style={{ fontWeight: 800 }}>Whitmore Library</div>
          <div style={{ fontSize: '0.95rem' }}>Available 24/7 for students</div>
        </HeroCaption>
      </HeroImage>
      <ActionsList>
        <Action>
          <div style={{ fontSize: 20 }}>🗓️</div>
          <div>Reserve Study Room</div>
        </Action>
        <Action>
          <div style={{ fontSize: 20 }}>📝</div>
          <div>Book Research Consultation</div>
        </Action>
      </ActionsList>
      <Occupancy>
        Current occupancy: <span style={{ color: '#223046', fontWeight: 700 }}>42%</span> • Light
      </Occupancy>
    </ResourcesWrapper>
  );
};

export default Resources;


